<mat-toolbar class="d-flex bg-white border-bottom">
  <h2>Create New Report</h2>
</mat-toolbar>
